var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tabs"},_vm._l((_vm.dataTab),function(item,index){return _c('div',{key:index,class:[
            'tabChild',
            item.path === _vm.$route.path || item.name === _vm.tabActive
                ? 'tabActive'
                : ''
        ],style:({ width: item?.width + '%' }),on:{"click":function($event){return _vm.onActions(item)}}},[_c('a',[_c('span',{class:item.icon},[_vm._v(_vm._s(item.title))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }